/*
* Pipeline Theme — Elwards Leather Custom JS
*/

(function() {

  /* =========================================================================
     "You Save" badge — update save percent on variant change
     ========================================================================= */
  document.addEventListener('theme:variant:change', function(event) {
    var variant = event.detail.variant;
    var container = event.target;
    if (!variant) return;

    var savePercentEls = container.querySelectorAll('[data-save-percent]');
    if (savePercentEls.length && variant.compare_at_price && variant.compare_at_price > variant.price) {
      var percent = Math.floor(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
      savePercentEls.forEach(function(el) {
        el.textContent = percent + '%';
      });
    }

    updateStickyATCVariant(variant);
  });

  function formatMoney(cents) {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      var formatted = Shopify.formatMoney(cents, theme.moneyFormat);
      if (theme.settings.currency_code_enable) {
        formatted += ' ' + theme.currencyCode;
      }
      return formatted;
    }
    return (cents / 100).toFixed(2);
  }

  function updateStickyATCVariant(variant) {
    var bar = document.querySelector('[data-sticky-atc]');
    if (!bar) return;

    var priceEl = bar.querySelector('[data-sticky-atc-current-price]');
    var compareEl = bar.querySelector('[data-sticky-atc-compare-price]');
    var btn = bar.querySelector('[data-sticky-atc-button]');
    var btnText = bar.querySelector('[data-sticky-atc-text]');
    var btnPrice = bar.querySelector('[data-sticky-atc-btn-price]');
    var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;

    if (priceEl) {
      priceEl.innerHTML = formatMoney(variant.price);
      priceEl.classList.toggle('sticky-atc__price--sale', onSale);
    }
    if (compareEl) {
      compareEl.innerHTML = onSale ? formatMoney(variant.compare_at_price) : '';
      compareEl.style.display = onSale ? '' : 'none';
    }
    if (btnPrice) {
      btnPrice.innerHTML = '<span class="sticky-atc__button-sep">—</span>' + formatMoney(variant.price);
    }
    if (btn && btnText) {
      btn.disabled = !variant.available;
      btnText.textContent = variant.available
        ? (theme.strings.addToCart || 'Add to cart')
        : (theme.strings.soldOut || 'Sold out');
    }
  }

  /* =========================================================================
     Sticky Add to Cart bar — scroll-based show/hide
     ========================================================================= */
  function initStickyATC() {
    var bar = document.querySelector('[data-sticky-atc]');
    if (!bar) return;

    /* Find the product form wrapper — more reliable than the button itself */
    var formWrapper = document.querySelector('[data-product-form]');
    if (!formWrapper) {
      formWrapper = document.querySelector('form[action="/cart/add"]');
    }
    if (!formWrapper) return;

    var mainButton = formWrapper.querySelector('[data-add-to-cart]') || formWrapper.querySelector('button[name="add"]');
    var stickyButton = bar.querySelector('[data-sticky-atc-button]');

    /* Hide the bar once the viewport reaches the footer / subfooter — that's
       the only "end of page" area we don't want it covering. */
    var hideZoneSelector = 'footer,[id^="shopify-section-footer"],[id^="shopify-section-subfooter"]';
    var hideZoneTop = Infinity;
    function recomputeHideZone() {
      var min = Infinity;
      document.querySelectorAll(hideZoneSelector).forEach(function (el) {
        if (el === bar || bar.contains(el) || el.contains(bar)) return;
        var rect = el.getBoundingClientRect();
        var absTop = rect.top + window.scrollY;
        if (absTop > 0 && absTop < min) min = absTop;
      });
      hideZoneTop = min;
    }

    recomputeHideZone();

    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function() {
        var rect = formWrapper.getBoundingClientRect();
        var formPassed = rect.bottom < 0;
        var nearHideZone = (window.scrollY + window.innerHeight) >= (hideZoneTop - 20);
        if (formPassed && !nearHideZone) {
          bar.classList.add('is-visible');
          bar.setAttribute('aria-hidden', 'false');
        } else {
          bar.classList.remove('is-visible');
          bar.setAttribute('aria-hidden', 'true');
        }
        ticking = false;
      });
    }

    function onLayoutChange() {
      recomputeHideZone();
      onScroll();
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onLayoutChange);
    window.addEventListener('load', onLayoutChange);

    onScroll();

    /* Click sticky button -> trigger main form + mirror animation */
    if (stickyButton && mainButton && !stickyButton._bound) {
      stickyButton._bound = true;
      stickyButton.addEventListener('click', function() {
        /* Show loading state */
        stickyButton.classList.add('loading');
        stickyButton.classList.remove('has-success');

        /* Trigger the real form */
        mainButton.click();

        /* Watch for the main button's success state */
        var checkCount = 0;
        var checker = setInterval(function() {
          checkCount++;
          if (mainButton.classList.contains('has-success')) {
            clearInterval(checker);
            stickyButton.classList.remove('loading');
            stickyButton.classList.add('has-success');
            setTimeout(function() {
              stickyButton.classList.remove('has-success');
            }, 2000);
          } else if (checkCount > 50) {
            /* Timeout after 5s — reset */
            clearInterval(checker);
            stickyButton.classList.remove('loading');
          }
        }, 100);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyATC);
  } else {
    initStickyATC();
  }
  document.addEventListener('shopify:section:load', initStickyATC);

  /* =========================================================================
     Size Guide modal — open/close
     ========================================================================= */
  document.addEventListener('click', function(e) {
    var trigger = e.target.closest('[data-size-guide-trigger]');
    if (trigger) {
      e.preventDefault();
      var modal = document.querySelector('[data-size-guide-modal]');
      if (modal) {
        modal.classList.add('is-open');
        document.body.style.overflow = 'hidden';
      }
      return;
    }

    var closeBtn = e.target.closest('[data-size-guide-close]');
    if (closeBtn) {
      var openModal = closeBtn.closest('[data-size-guide-modal]');
      if (openModal) {
        openModal.classList.remove('is-open');
        document.body.style.overflow = '';
      }
    }
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      var openModal = document.querySelector('[data-size-guide-modal].is-open');
      if (openModal) {
        openModal.classList.remove('is-open');
        document.body.style.overflow = '';
      }
    }
  });

})();

/* =========================================================================
   Collection search + quick filters (snippets/collection-quick-filters.liquid)
   - Chips toggle one value per filter and keep the other URL params
   - After the theme's AJAX filtering, the chip row is re-rendered
   - Search hides products whose title does not match; on paginated
     collections the remaining pages are loaded on the first search
   ========================================================================= */
(function() {
  var bar = document.querySelector('[data-quick-filters]');
  if (!bar) return;

  var sectionId = bar.getAttribute('data-section-id');
  var section = bar.closest('[data-section-type="collection"]') || document;

  function currentParams() {
    var params = new URLSearchParams(window.location.search);
    params.delete('page');
    params.delete('section_id');
    return params;
  }

  function go(params) {
    var query = params.toString();
    window.location.href = window.location.pathname + (query ? '?' + query : '');
  }

  function chipParams() {
    var names = [];
    bar.querySelectorAll('[data-quick-filter]').forEach(function(chip) {
      var name = chip.getAttribute('data-param');
      if (names.indexOf(name) === -1) names.push(name);
    });
    return names;
  }

  /* ---------- Chips ---------- */
  bar.addEventListener('click', function(event) {
    var chip = event.target.closest('[data-quick-filter], [data-quick-filter-all], [data-quick-sort]');
    if (!chip) return;
    event.preventDefault();

    var params = currentParams();

    if (chip.hasAttribute('data-quick-filter-all')) {
      chipParams().forEach(function(name) { params.delete(name); });
      if (params.get('sort_by') === 'price-ascending' && bar.querySelector('[data-quick-sort]')) {
        params.delete('sort_by');
      }
    } else if (chip.hasAttribute('data-quick-sort')) {
      var sort = chip.getAttribute('data-quick-sort');
      if (params.get('sort_by') === sort) {
        params.delete('sort_by');
      } else {
        params.set('sort_by', sort);
      }
    } else {
      var name = chip.getAttribute('data-param');
      var value = chip.getAttribute('data-value');
      var wasActive = params.getAll(name).indexOf(value) !== -1;
      params.delete(name);
      if (!wasActive) params.append(name, value);
    }

    go(params);
  });

  /* ---------- Dropdown chips ---------- */
  document.addEventListener('click', function(event) {
    if (event.target.closest && event.target.closest('[data-quick-filter-panel]')) return;
    bar.querySelectorAll('[data-quick-filter-dropdown][open]').forEach(function(dropdown) {
      if (!dropdown.contains(event.target)) dropdown.removeAttribute('open');
    });
  });
  // Mobile: the chip row scrolls sideways, and iOS Safari clips anything positioned inside it.
  // So on phones an opened dropdown shows its values in a floating panel (data-quick-filter-panel)
  // that lives outside the chip row but is placed right under the dropdown button, like on desktop.
  var panel = bar.querySelector('[data-quick-filter-panel]');
  var chipRow = bar.querySelector('[data-quick-filter-chips]');
  var mobileQuery = window.matchMedia('(max-width: 767px)');
  function placePanel() {
    var opened = bar.querySelector('[data-quick-filter-dropdown][open]');
    if (!panel || panel.hidden || !opened) return;
    var summary = opened.querySelector('summary');
    var barRect = bar.getBoundingClientRect();
    var sumRect = summary.getBoundingClientRect();
    panel.style.minWidth = Math.round(sumRect.width) + 'px';
    var maxLeft = barRect.width - panel.offsetWidth;
    var left = Math.min(Math.max(sumRect.left - barRect.left, 0), Math.max(maxLeft, 0));
    panel.style.left = Math.round(left) + 'px';
    panel.style.top = Math.round(sumRect.bottom - barRect.top + 6) + 'px';
  }
  function renderPanel() {
    if (!panel) return;
    var opened = bar.querySelector('[data-quick-filter-dropdown][open]');
    if (!opened || !mobileQuery.matches) {
      panel.hidden = true;
      panel.innerHTML = '';
      return;
    }
    var menu = opened.querySelector('.quick-filters__menu');
    panel.innerHTML = menu ? menu.innerHTML : '';
    panel.hidden = false;
    placePanel();
  }
  bar.addEventListener('toggle', function(event) {
    var opened = event.target;
    if (!opened.matches || !opened.matches('[data-quick-filter-dropdown]')) return;
    if (opened.open) {
      bar.querySelectorAll('[data-quick-filter-dropdown][open]').forEach(function(dropdown) {
        if (dropdown !== opened) dropdown.removeAttribute('open');
      });
    }
    renderPanel();
  }, true);
  if (chipRow) chipRow.addEventListener('scroll', placePanel, { passive: true });
  window.addEventListener('resize', placePanel);
  if (mobileQuery.addEventListener) mobileQuery.addEventListener('change', renderPanel);

  /* ---------- Search ---------- */
  var input = bar.querySelector('[data-quick-search]');
  var clearButton = bar.querySelector('[data-quick-search-clear]');
  var emptyMessage = bar.querySelector('[data-quick-search-empty]');
  var allPagesLoaded = false;
  var loadingPages = null;
  var searchTimer = null;

  function grid() {
    return section.querySelector('[data-products-grid] .js-grid');
  }

  function pagination() {
    var holder = section.querySelector('[data-products-grid] .pagination-custom');
    return holder ? holder.parentElement : null;
  }

  function normalise(text) {
    return (text || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').trim();
  }

  function pageCount() {
    var max = 1;
    section.querySelectorAll('[data-products-grid] .pagination-custom__num').forEach(function(item) {
      var number = parseInt(item.textContent, 10);
      if (number > max) max = number;
    });
    return max;
  }

  function loadAllPages() {
    if (allPagesLoaded) return Promise.resolve();
    if (loadingPages) return loadingPages;

    var pages = pageCount();
    var current = parseInt(new URLSearchParams(window.location.search).get('page') || '1', 10);
    var requests = [];

    for (var page = 1; page <= pages; page++) {
      if (page === current) continue;
      var params = currentParams();
      params.set('page', page);
      params.set('section_id', sectionId);
      requests.push(
        fetch(window.location.pathname + '?' + params.toString())
          .then(function(response) { return response.text(); })
          .then(function(html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            return Array.prototype.slice.call(doc.querySelectorAll('[data-products-grid] .js-grid > div'));
          })
          .catch(function() { return []; })
      );
    }

    loadingPages = Promise.all(requests).then(function(results) {
      var target = grid();
      if (!target) return;
      results.forEach(function(items) {
        items.forEach(function(item) {
          item.setAttribute('data-quick-search-extra', '');
          item.hidden = true;
          target.appendChild(item);
        });
      });
      allPagesLoaded = true;
      loadingPages = null;
    });
    return loadingPages;
  }

  function applySearch() {
    var target = grid();
    if (!target || !input) return;
    var query = normalise(input.value);
    var visible = 0;

    target.querySelectorAll(':scope > div').forEach(function(item) {
      var card = item.querySelector('product-grid-item');
      if (!card) return;
      var isExtra = item.hasAttribute('data-quick-search-extra');
      var matches = query === ''
        ? !isExtra
        : normalise(card.getAttribute('aria-label')).indexOf(query) !== -1;
      item.hidden = !matches;
      if (matches) visible++;
    });

    var pager = pagination();
    if (pager) pager.hidden = query !== '';
    if (clearButton) clearButton.hidden = query === '';
    if (emptyMessage) emptyMessage.hidden = query === '' || visible > 0;
  }

  function onSearch() {
    clearTimeout(searchTimer);
    searchTimer = setTimeout(function() {
      if (input.value.trim() !== '' && pageCount() > 1 && !allPagesLoaded) {
        loadAllPages().then(applySearch);
      } else {
        applySearch();
      }
    }, 150);
  }

  if (input) {
    input.addEventListener('input', onSearch);
    input.addEventListener('keydown', function(event) {
      if (event.key === 'Enter') event.preventDefault();
    });
  }
  if (clearButton) {
    clearButton.addEventListener('click', function() {
      input.value = '';
      applySearch();
      input.focus();
    });
  }

  /* ---------- Keep in sync with the theme's AJAX filtering ---------- */
  var productsGrid = section.querySelector('[data-products-grid]');
  if (!productsGrid || !window.MutationObserver) return;

  var refreshTimer = null;
  var lastSearch = window.location.search;

  new MutationObserver(function() {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(function() {
      if (window.location.search === lastSearch) return;
      lastSearch = window.location.search;

      // The grid was replaced: pages need to be loaded again for the new results
      allPagesLoaded = false;
      if (input && input.value.trim() !== '') onSearch();

      var params = currentParams();
      params.set('section_id', sectionId);
      fetch(window.location.pathname + '?' + params.toString())
        .then(function(response) { return response.text(); })
        .then(function(html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-quick-filter-chips]');
          var chips = bar.querySelector('[data-quick-filter-chips]');
          if (fresh && chips) chips.innerHTML = fresh.innerHTML;
        })
        .catch(function() {});
    }, 300);
  }).observe(productsGrid, { childList: true });
})();
